var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoLogin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.429,
    height: 52.431,
    viewBox: "0 0 52.429 52.431",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#3553b2;}.b{fill:#23d8f8;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-687.094 -675.688)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M718.262,705.528a8.456,8.456,0,0,1-8.431,8.431h0a8.6,8.6,0,0,1-8.577-8.577h0a8.456,8.456,0,0,1,8.431-8.432h3.769a.57.57,0,0,0,.57-.569v-13.05a.568.568,0,0,0-.568-.568h-3.879a22.549,22.549,0,0,0-22.483,22.483h0a22.94,22.94,0,0,0,22.872,22.873h0a22.55,22.55,0,0,0,22.483-22.484v-3.878a.568.568,0,0,0-.568-.568H718.828a.565.565,0,0,0-.566.566Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 21.26,
    height: 7.087,
    rx: 1,
    transform: "translate(718.262 682.775)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 21.26,
    height: 7.087,
    rx: 1,
    transform: "translate(725.349 696.948) rotate(-90)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLogin);
export default __webpack_public_path__ + "static/media/logoLogin.7df6a29d.svg";
export { ForwardRef as ReactComponent };